import { createSlice } from '@reduxjs/toolkit';

const userSlice = createSlice({
    name: 'user',
    initialState: {
        id: null,
        email: null,
        approvalStatus: null,
        savedQueries: [],
        createdAt: null,
        updatedAt: null,
    },
    reducers: {
        setUser: (state, action) => {
            return { ...state, ...action.payload };
        },
        clearUser: (state) => {
            return {
                id: null,
                email: null,
                approvalStatus: null,
                savedQueries: [],
                createdAt: null,
                updatedAt: null,
            };
        },
        updateSavedQueries: (state, action) => {
            state.savedQueries = action.payload;
        },
    },
});

export const { setUser, clearUser, updateSavedQueries } = userSlice.actions;
export default userSlice.reducer;